
import React from 'react';
import {useLocation} from 'react-router-dom';

import {Helmet} from 'views/module';

import PlaybooksScene from 'views/scenes/playbooks/Playbooks';

const PlaybooksPage = (props) => {
  const location = useLocation();
  const initialSelectedPlaybookRn = location.state?.selectedPlaybookRn || null;

  return (
    <>
      <Helmet>
        <title>Quilt: Playbooks</title>
      </Helmet>
      <PlaybooksScene
        initialSelectedPlaybookRn={initialSelectedPlaybookRn}
      />
    </>
  );
};

export default PlaybooksPage;
